import React from 'react'

const CreateCategory = () => {
  return (
    <div>Create Category</div>
  )
}

export default CreateCategory